var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidationWarningWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.595 18.482"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.092 15.552L12.531 1.301s-1.759-2.928-3.518 0L.453 15.552s-1.759 2.93 1.658 2.93h17.324s3.416 0 1.657-2.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce732a",
    d: "M12.02 11.932l-2.444.001V4.715h2.443l.001 7.217zM9.575 13.743h2.444v2.443H9.575v-2.443z"
  })));
}
export default SvgValidationWarningWhite;